import React, { useState } from 'react';
import logo from "./assets/images/logo.png";
import { Link, NavLink } from 'react-router-dom';
import { Navbar, Nav, Container, Offcanvas } from 'react-bootstrap'; 
import logoName from "./assets/images/logo_name.png"
function HeaderTop() {
  const [show, setShow] = useState(false); 
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);  

  

  return (
    <div className='header_sty'>
      <Navbar expand="lg" className="shadow-sm menu_style">
        <Container>
          <div className='d-flex align-items-center justify-content-between wmob100'>
            <Navbar.Brand as={Link} to="/" className='d-flex flex-wrap align-items-center'>
              <img src={logo} alt="Maa Pateswari University, Balrampur" className='logoimg' />
              <div className="ms-2 logoName">
                माँ पाटेश्वरी विश्वविद्यालय, बलरामपुर<br/>
                Maa Pateswari University, Balrampur
              </div>
            </Navbar.Brand>
            <Navbar.Toggle onClick={handleShow}>
              <i className="fa-solid fa-bars"></i>
            </Navbar.Toggle>
          </div>

          <Navbar.Offcanvas show={show} onHide={handleClose} placement="start">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
              <div className='d-flex'>
                <img src={logoName} alt=" Maa Pateswari University, Balrampur" height="40" /> 
              </div>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-end flex-grow-1 pe-3">
                <NavLink className="nav-link" to="/" onClick={handleClose}>
                  <i className="bi bi-house-door"></i> Home
                </NavLink>
                <NavLink className="nav-link" to="/about-us" onClick={handleClose}>
                  About Us
                </NavLink>
                <NavLink className="nav-link" to="/blog" onClick={handleClose}>
                  Blog
                </NavLink>
                <NavLink className="nav-link" to="/contact-us" onClick={handleClose}>
                  Contact Us
                </NavLink>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </div>
  );
}

export default HeaderTop;
